import { createStore } from 'vuex';

const store = createStore({
	state(){
		return {
			currentLanguage:{
			}
		}
	},
	mutations:{
		translate(state,payload){
			state.currentLanguage = payload;
		},
		changeCalculatorButtonText(state,payload){
			state.currentLanguage.show_calculator_button_text = payload;
		}
	},
	getters:{
		translations(state){
			return state.currentLanguage;
		}
	},
	actions:{
		translate(context) {
			const currentUrl = window.location.protocol +'//' + window.location.hostname;
			console.log('currentUrl',currentUrl);
			const currentLanguage = document.getElementById('vue-lang').value;

			fetch(currentUrl+'/vue/i18n/'+currentLanguage+'.json')
				.then((response)=>{
					if (response.ok) {
						return response.json();
					}
				}).then((data)=>{
				context.commit('translate',data);
			});
		}
	}
});



export default store;
